import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { styled } from "@mui/material/styles"

const SpinnerContainer = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
}))

const Spinner = () => {
  return (
    <SpinnerContainer>
      <CircularProgress/>
    </SpinnerContainer>
  )
}

export default Spinner
